import { DEFAULT_STORE_ID } from 'services/utility/constants'

export const getStoreId = ({ service_eligibility: serviceEligibility = [{}] }) => {
  const [{
    accesspoint_list: [{
      fulfill_store_id: storeId = DEFAULT_STORE_ID,
    }] = [{}],
  }] = serviceEligibility

  return storeId
}



// WEBPACK FOOTER //
// ./services/api/parser/serviceEligibility/index.js